module.exports = __webpack_public_path__ + "static/media/cart.7d20d947.svg";